import { HttpClientPlugin } from '../types';
import { defaultLocale } from '@/src/lib/dictionary/settings';
import { getDialectForLocale } from '@/src/lib/dictionary/utils';

export function createWithLocalePlugin(
  getLangCookie: () => Promise<string | undefined> | string | undefined,
): HttpClientPlugin {
  return {
    async beforeRequest(url, options) {
      if (options.headers?.get('Accept-Language')) {
        return { url, options };
      }

      let { locale } = options;

      if (!locale) {
        locale = await getLangCookie();
      }

      if (!locale) {
        locale = defaultLocale;
      }

      options.headers = new Headers(options.headers);
      options.headers.append('Accept-Language', getDialectForLocale(locale));

      return { url, options };
    },
  };
}
